import { render, staticRenderFns } from "./MedicationsInotrope.vue?vue&type=template&id=56328940"
import script from "./MedicationsInotrope.vue?vue&type=script&lang=js"
export * from "./MedicationsInotrope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports